<template>
    <!-- 车型对比 START：以下为车型参数对比区域（含<=2列与>2列两种布局） -->
    <div ref="carType" class="comparison-container">
      <!-- 固定头部区域 -->
      <div class="fixed-header-container" v-if="textSpecslList.length > 2" @touchstart="onHeaderTouchStart" @touchmove="onHeaderTouchMove" @touchend="onHeaderTouchEnd" @touchcancel="onHeaderTouchEnd">
        <div class="fixed-header-wrapper" ref="fixedHeaderWrapper" :style="'width:' + columnWidth * textSpecslList.length + 'px;'">
          <div v-for="(item, index) in textSpecslList" :key="'header-' + index" class="car-header-fixed">
            <div class="car-header-fixed-content">
                <div class="car-title">{{ item.carSeries || '' }}</div>
                <div class="car-price">{{ item.carModelName || '' }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="car-comparison-container" v-if="textSpecslList.length <= 2">
        <div v-for="(item, index) in textSpecslList" :key="index" class="car-item">
          <div class="car-header" :style="textSpecslList.length == 1 ? 'width:100%' : 'width: calc(50vw - 290px);'">
            <div class="car-title">{{ item.carSeries || '' }}</div>
            <div class="car-price">{{ item.carModelName || '' }}</div>
          </div>
          <div class="car-parameters" v-if="checkCarSeries(textSpecslList)">
            <div v-for="(value, key) in item.sections" :key="key" class="parameter-item">
              <div class="parameter-title-header">
                <div class="parameter-title" :style="index == 0 ? 'opacity: 1;' : 'opacity: 0;'">{{ value.sectionName }}</div>

                <div v-if="index === textSpecslList.length - 1" class="toggle-icon" @click="toggleSection(key)">
                  <el-button class="custom-icon-btn" type="text" :icon="isSectionExpanded[key] ? 'ArrowUp' : 'ArrowDown'"></el-button>
                </div>
              </div>
              <div class="parameter-title-line" :style="index == 0 ? '' : ''"></div>
              <div >
                <div
                  v-for="(value1, key1) in value.fields"
                  :key="key1"
                  class="parameter-content"
                  :style="index == 0 ? ' opacity:' + (value1 === 'null' ? '0' : '1') : ' opacity: ' + (value1 === 'null' ? '0' : '1')"
                >
                  <div class="parameter-name" :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : 'opacity:' + (value1 === 'null' ? '0' : '1')">
                    {{ key1 }}
                  </div>

                  <div
                    v-if="value1 != 'true'"
                    class="parameter-value"
                    :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : '  opacity:' + (value1 === 'null' ? '0' : '1')"
                  >
                    {{ value1 }}
                  </div>

                  <div v-else class="parameter-value">
                    <span
                      style="display: inline-block; width: 8px; height: 8px; background-color: black; border-radius: 50%; margin-right: 5px"
                      :style="index == 0 ? 'margin-left: 0px; ' : '   '"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 0000000000000000 -->
          <div class="car-parameters" v-else>
            <div v-for="(value, key) in item.sections" :key="key" class="parameter-item">
              <div class="parameter-title-header">
                <div class="parameter-title">
                  {{ value.sectionName }}
                </div>
              </div>
              <div class="parameter-title-line" :style="index == 0 ? '' : ''"></div>
              <div >
                <div
                  v-for="(value1, key1) in value.fields"
                  :key="key1"
                  class="parameter-content"
                  :style="index == 0 ? ' opacity:' + (value1 === 'null' ? '0' : '1') : ' opacity: ' + (value1 === 'null' ? '0' : '1')"
                >
                  <div class="parameter-name" :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : 'opacity:' + (value1 === 'null' ? '0' : '1')">
                    {{ key1 }}
                  </div>

                  <div
                    v-if="value1 != 'true'"
                    class="parameter-value"
                    :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : '  opacity:' + (value1 === 'null' ? '0' : '1')"
                  >
                    {{ value1 }}
                  </div>

                  <div v-else class="parameter-value">
                    <span
                      style="display: inline-block; width: 8px; height: 8px; background-color: black; border-radius: 50%; border-radius: 50%; margin-right: 5px"
                      :style="index == 0 ? 'margin-left: 0px; ' : '   '"
                    ></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 0000000000000000 -->
        </div>
      </div>

      <!-- 滚动容器区域 -->
      <div 
        v-else
        class="car-comparison-container-scrollable"
        ref="scrollContainer"
        @scroll="handleScroll"
        @touchstart="onContentTouchStart"
        @touchmove="onContentTouchMove"
        @touchend="onContentTouchEnd"
        @touchcancel="onContentTouchEnd"
      >
        <div class="car-content-wrapper" :style="'width:' + columnWidth * textSpecslList.length + 'px;'">
          <div v-for="(item, index) in textSpecslList" :key="index" class="car-item">
            <!-- 占位头部，保持布局一致 -->
            <!-- <div class="car-header-placeholder"></div> -->
            <div class="car-parameters" v-if="checkCarSeries(textSpecslList)">
              <div v-for="(value, key) in item.sections" :key="key" class="parameter-item">
                <div class="parameter-title-header">
                  <div class="parameter-title" :style="index == 0 ? 'opacity: 1;' : 'opacity: 0;'">
                    {{ value.sectionName }}
                  </div>

                  <div v-if="index === textSpecslList.length - 1" class="toggle-icon" @click="toggleSection(key)">
                    <el-button class="custom-icon-btn" type="text" :icon="isSectionExpanded[key] ? 'ArrowUp' : 'ArrowDown'"></el-button>
                  </div>
                </div>

                <div class="parameter-title-line" v-if="index === 0" ></div>
                <div class="parameter-title-line" v-else style="margin-left: 0px; margin-right: 0px"></div>
                <div >
                  <div
                    v-for="(value1, key1) in value.fields"
                    :key="key1"
                    class="parameter-content"
                    :style="index == 0 ? ' opacity:' + (value1 === 'null' ? '0' : '1') : ' opacity: ' + (value1 === 'null' ? '0' : '1')"
                  >
                    <div class="parameter-name" :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : 'opacity:' + (value1 === 'null' ? '0' : '1')">
                      {{ key1 }}
                    </div>
                    <div
                      v-if="value1 != 'true'"
                      class="parameter-value"
                      :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : '  opacity:' + (value1 === 'null' ? '0' : '1')"
                    >
                      {{ value1 }}
                    </div>
                    <div v-else class="parameter-value">
                      <span
                        style="display: inline-block; width: 8px; height: 8px; background-color: black; border-radius: 50%; margin-right: 5px"
                        :style="index == 0 ? 'margin-left: 0px; ' : '   '"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 1111111111111111111 -->

            <div class="car-parameters" v-else>
              <div v-for="(value, key) in item.sections" :key="key" class="parameter-item">
                <div class="parameter-title-header">
                  <div class="parameter-title">
                    {{ value.sectionName }}
                  </div>
                </div>

                <div class="parameter-title-line" v-if="index === 0" style=" "></div>
                <div class="parameter-title-line" v-else style="margin-left: 0px; margin-right: 0px"></div>
                <div >
                  <div
                    v-for="(value1, key1) in value.fields"
                    :key="key1"
                    class="parameter-content"
                    :style="index == 0 ? ' opacity:' + (value1 === 'null' ? '0' : '1') : ' opacity: ' + (value1 === 'null' ? '0' : '1')"
                  >
                    <div class="parameter-name" :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : 'opacity:' + (value1 === 'null' ? '0' : '1')">
                      {{ key1 }}
                    </div>
                    <div
                      v-if="value1 != 'true'"
                      class="parameter-value"
                      :style="index == 0 ? 'margin-left: 0px;opacity:' + (value1 === 'null' ? '0' : '1') : '  opacity:' + (value1 === 'null' ? '0' : '1')"
                    >
                      {{ value1 }}
                    </div>
                    <div v-else class="parameter-value">
                      <span
                        style="display: inline-block; width: 8px; height: 8px; background-color: black; border-radius: 50%; margin-right: 5px"
                        :style="index == 0 ? 'margin-left: 0px; ' : '   '"
                      ></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- 1111111111111111111 -->
          </div>
        </div>
      </div>
    </div>
    <!-- 车型对比 END：以上为车型参数对比区域 -->
  </template>
  <script>
  import { aiUrl } from "@/config/base";
  export default {
    name: 'CarComparison',
    props: {
      question: {
        type: String,
        required: true,
        default: '[\"K3\",\"K5\"]'
      }
    },
    data() {
      return {
        carList: [],
        isSectionExpanded: {}, 
        textSpecslList: [],
        scrollLeft: 0, // 新增滚动位置属性（用于非 >2 列场景，>2 列改为原生 transform）
        columnWidth: 330,
        _rafId: null,
        _isTicking: false,
        _nextScrollLeft: 0,
        _headerIsTouching: false,
        _headerLastTouchX: 0,
        _headerStartX: 0,
        _headerStartY: 0,
        _headerAxisLocked: null, // 'x' | 'y' | null
        _contentIsTouching: false,
        _contentLastTouchX: 0,
        _suppressScrollSync: false,
        _contentStartX: 0,
        _contentStartY: 0,
        _contentAxisLocked: null, // 'x' | 'y' | null
        _vhListenersBound: false,
        token: '',
      };
    },
    created() {
      const userInfo = localStorage.getItem('user');
      var token=''
      if(userInfo){
        this.userInfo = JSON.parse(userInfo)
        token = this.userInfo.token
      }
      this.token = token
    },
    methods: {
        updateColumnWidth() {
      try {
        const vw = typeof window !== 'undefined' ? window.innerWidth : 1024;
        if (vw <= 767) {
          // 以 194px 按 375 适配
          this.columnWidth = Math.round(244 / 375 * vw);
        } else {
          this.columnWidth = 330;
        }
      } catch (_) {
        this.columnWidth = 330;
      }
    },
        checkCarSeries(textSpecslList) {
      var showDuiBi = true;
      for (let i = 1; i < textSpecslList.length; i++) {
        if (textSpecslList[i].carSeries !== textSpecslList[0].carSeries) {
          showDuiBi = false;
          break; // 如果有不同的 carSeries，设置 showDuiBi 为 false 并跳出循环
        }
      }
      return showDuiBi;
    },
    // 车型对比 START：根据关键词检索并规整参数分组与字段
    fetchSelectTextListSpecslByLike(question) {
      const that = this;
      this.textSpecslList = [];
      this.isSectionExpanded = {};
      this.$axios
        .post(
          `${aiUrl}keyword/selectTextListSpecslByLike`,
          { question: (typeof question !== 'undefined' && question !== null) ? question : this.question, number: 0 },
          {
            headers: {
              token: that.token,
            },
          }
        )
        .then((res) => {
          const response = res.data || res;
          if (response.code == 200) {
            this.textSpecslList = response.data;

          // Normalize the sections data to fill missing fields with 'null'
          if (this.textSpecslList.length > 1) {
            let isSame = true;
            const firstCarSeries = this.textSpecslList[0].carSeries;
            for (let i = 1; i < this.textSpecslList.length; i++) {
              if (this.textSpecslList[i].carSeries !== firstCarSeries) {
                isSame = false;
                break;
              }
            }
            if (isSame) {
              // 所有 carSeries 相同的处理逻辑
              // 收集所有 sectionName
              const allSectionNames = new Set();
              this.textSpecslList.forEach((item) => {
                item.sections.forEach((section) => {
                  allSectionNames.add(section.sectionName);
                });
              });

              // 获取左侧第一条数据的 sectionName 顺序
              const firstItemSectionNames = this.textSpecslList[0].sections.map((section) => section.sectionName);

              // 生成排序数组，先按左侧第一条数据的顺序，再补充其他
              const sortedSectionNames = [...firstItemSectionNames];
              allSectionNames.forEach((name) => {
                if (!sortedSectionNames.includes(name)) {
                  sortedSectionNames.push(name);
                }
              });

              // 为每个数据补充缺失的 sectionName 并按排序数组排序
              this.textSpecslList.forEach((item) => {
                const existingSectionNames = item.sections.map((section) => section.sectionName);
                allSectionNames.forEach((sectionName) => {
                  if (!existingSectionNames.includes(sectionName)) {
                    item.sections.push({
                      sectionName,
                      fields: {}
                    });
                  }
                });

                item.sections.sort((a, b) => {
                  const indexA = sortedSectionNames.indexOf(a.sectionName);
                  const indexB = sortedSectionNames.indexOf(b.sectionName);
                  return indexA - indexB;
                });
              });

              // 找出每个 sectionName 下的最大字段数
              const maxFieldsPerSection = {};
              this.textSpecslList.forEach((item) => {
                item.sections.forEach((section) => {
                  const fieldCount = Object.keys(section.fields).length;
                  if (!maxFieldsPerSection[section.sectionName] || fieldCount > maxFieldsPerSection[section.sectionName]) {
                    maxFieldsPerSection[section.sectionName] = fieldCount;
                  }
                });
              });

              // 为每个 section 补充缺失的字段
              this.textSpecslList.forEach((item) => {
                item.sections.forEach((section) => {
                  const currentFieldCount = Object.keys(section.fields).length;
                  const missingCount = maxFieldsPerSection[section.sectionName] - currentFieldCount;
                  if (missingCount > 0) {
                    for (let i = currentFieldCount + 1; i <= maxFieldsPerSection[section.sectionName]; i++) {
                      section.fields[`field${i}`] = 'null';
                    }
                  }
                });
              });
            } else {
              this.$nextTick(() => {
                if (this.textSpecslList.length > 0) {
                  this.textSpecslList[0].sections.forEach((section, key) => {
                    this.isSectionExpanded[key] = true;
                  });
                }
              });
            }
          }

          this.$nextTick(() => {
            if (this.textSpecslList.length > 0) {
              this.textSpecslList[0].sections.forEach((section, key) => {
                this.isSectionExpanded[key] = true;
              });
            }
          });
        } else {
          this.$message.error(response.msg);
        }
      });
    },
    // 车型对比 END

    // 车型对比：展开/收起参数分组
    toggleSection(key) {
      this.isSectionExpanded[key] = !this.isSectionExpanded[key];
    },
    
    // 处理滚动同步
    handleScroll(event) {
      if (this._suppressScrollSync) return;
      const sl = event.target && event.target.scrollLeft ? event.target.scrollLeft : 0;
      this._nextScrollLeft = sl;
      if (this._isTicking) return;
      this._isTicking = true;
      const cb = () => {
        const header = this.$refs.fixedHeaderWrapper;
        if (header) {
          // 使用整数像素避免亚像素抖动
          const x = -Math.round(this._nextScrollLeft);
          header.style.transform = `translate3d(${x}px,0,0)`;
        } else {
          this.scrollLeft = this._nextScrollLeft;
        }
        this._isTicking = false;
      };
      this._rafId = (typeof window !== 'undefined' && window.requestAnimationFrame)
        ? window.requestAnimationFrame(cb)
        : setTimeout(cb, 16);
    },

    // 头部触摸驱动内容横向滚动（用于移动端让头部可拖动并同步内容）
    onHeaderTouchStart(e) {
      try {
        const touch = e.touches && e.touches[0] ? e.touches[0] : null;
        if (!touch) return;
        this._headerIsTouching = true;
        this._headerLastTouchX = touch.clientX;
        this._headerStartX = touch.clientX;
        this._headerStartY = touch.clientY;
        this._headerAxisLocked = null;
      } catch (_) {}
    },
    onHeaderTouchMove(e) {
      if (!this._headerIsTouching) return;
      try {
        const touch = e.touches && e.touches[0] ? e.touches[0] : null;
        if (!touch) return;
        const dx0 = touch.clientX - this._headerStartX;
        const dy0 = touch.clientY - this._headerStartY;
        if (this._headerAxisLocked == null) {
          const absX = Math.abs(dx0);
          const absY = Math.abs(dy0);
          if (absX > 8 || absY > 8) {
            this._headerAxisLocked = absX > absY ? 'x' : 'y';
          }
        }
        if (this._headerAxisLocked === 'y') {
          // 纵向主导：不处理，交给外层竖向滚动
          return;
        }
        const currentX = touch.clientX;
        const deltaX = currentX - this._headerLastTouchX;
        this._headerLastTouchX = currentX;
        const sc = this.$refs.scrollContainer;
        if (sc && typeof sc.scrollLeft === 'number') {
          // 头部右滑（deltaX>0）应使内容左移 => scrollLeft 减小
          sc.scrollLeft = sc.scrollLeft - deltaX;
        }
        // 横向主导时阻止页面的默认滚动弹性
        if (this._headerAxisLocked === 'x' && e.cancelable) e.preventDefault();
      } catch (_) {}
    },
    onHeaderTouchEnd() {
      this._headerIsTouching = false;
      this._headerAxisLocked = null;
    },

    // 内容触摸驱动（减少抖动：直接在 touchmove 中同步 header，并抑制滚动事件重复同步）
    onContentTouchStart(e) {
      try {
        const t = e.touches && e.touches[0] ? e.touches[0] : null;
        if (!t) return;
        this._contentIsTouching = true;
        this._contentLastTouchX = t.clientX;
        this._contentStartX = t.clientX;
        this._contentStartY = t.clientY;
        this._contentAxisLocked = null;
      } catch (_) {}
    },
    onContentTouchMove(e) {
      if (!this._contentIsTouching) return;
      try {
        const sc = this.$refs.scrollContainer;
        const header = this.$refs.fixedHeaderWrapper;
        const t = e.touches && e.touches[0] ? e.touches[0] : null;
        if (!t || !sc) return;
        const dx0 = t.clientX - this._contentStartX;
        const dy0 = t.clientY - this._contentStartY;
        if (this._contentAxisLocked == null) {
          const absX = Math.abs(dx0);
          const absY = Math.abs(dy0);
          if (absX > 8 || absY > 8) {
            this._contentAxisLocked = absX > absY ? 'x' : 'y';
            // 仅在横向手势时抑制滚动同步，避免与 scroll 事件竞争
            this._suppressScrollSync = this._contentAxisLocked === 'x';
          }
        }
        if (this._contentAxisLocked === 'y') {
          // 纵向主导：放行，允许外层滚动
          return;
        }
        const currentX = t.clientX;
        const deltaX = currentX - this._contentLastTouchX;
        this._contentLastTouchX = currentX;
        // 手指右移，内容应向左 => 减小 scrollLeft
        sc.scrollLeft = sc.scrollLeft - deltaX;
        if (header) {
          const x = -Math.round(sc.scrollLeft);
          header.style.transform = `translate3d(${x}px,0,0)`;
        }
        if (this._contentAxisLocked === 'x' && e.cancelable) e.preventDefault();
      } catch (_) {}
    },
    onContentTouchEnd() {
      this._contentIsTouching = false;
      this._contentAxisLocked = null;
      // 结束后短暂延迟再恢复滚动事件同步，避免最后一帧竞争
      setTimeout(() => { this._suppressScrollSync = false; }, 0);
    },

    // 动态设置移动端容器高度：calc(100dvh - 顶部距离)
    updateMobileContainerHeight() {
      try {
        if (typeof window === 'undefined') return;
        const vw = window.innerWidth || 1024;
        const root = this.$refs.carType;
        if (!root) return;
        if (vw <= 767) {
          const rect = root.getBoundingClientRect();
          const top = Math.max(0, Math.round(rect.top));
          const prefersSmallVh = (window.CSS && CSS.supports && CSS.supports('height', '100svh')) ? 'svh'
            : ((window.CSS && CSS.supports && CSS.supports('height', '100dvh')) ? 'dvh' : 'vh');
          root.style.height = `calc(100${prefersSmallVh} - ${top}px)`;
        } else {
          root.style.height = '';
        }
      } catch (_) {}
    },
    _bindViewportListeners() {
      if (this._vhListenersBound || typeof window === 'undefined') return;
      this._vhListenersBound = true;
      window.addEventListener('resize', this.updateMobileContainerHeight);
      window.addEventListener('orientationchange', this.updateMobileContainerHeight);
      window.addEventListener('scroll', this.updateMobileContainerHeight, { passive: true });
    },
    _unbindViewportListeners() {
      if (!this._vhListenersBound || typeof window === 'undefined') return;
      this._vhListenersBound = false;
      window.removeEventListener('resize', this.updateMobileContainerHeight);
      window.removeEventListener('orientationchange', this.updateMobileContainerHeight);
      window.removeEventListener('scroll', this.updateMobileContainerHeight);
    },
    },
    mounted() {
      this.fetchSelectTextListSpecslByLike(this.question);
      this.updateColumnWidth();
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.updateColumnWidth);
      }
      this.updateMobileContainerHeight();
      this._bindViewportListeners();
    },
    watch: {
      question(newVal) {
        this.fetchSelectTextListSpecslByLike(newVal);
      }
    },
    beforeDestroy() {
      try { if (this._rafId) cancelAnimationFrame(this._rafId); } catch (_) { try { clearTimeout(this._rafId); } catch (__) {} }
      this._unbindViewportListeners();
    }
  };
  </script>
  <style scoped lang="scss">
/* 让根容器支持父级高度填充与自定义列宽/头部高度变量 */
.comparison-container {
  width: 100%;
  height: 100%;
  --col-w: 330px;
  --header-h: 80px;
}

@media (min-width: 767px) {
  .comparison-container {
    overflow: auto;
  }
  
  // 固定头部容器
  .fixed-header-container {
    position: sticky;
    top: 0;
    z-index: 10;
    // background-color: #f2f2f2;
    // border-bottom: 1px solid #e0e0e0;
    overflow: hidden;
    height: var(--header-h); // 固定高度
    width: 100%;
    contain: layout paint; // 限定影响范围，减少重绘串扰
  }
  
  .fixed-header-wrapper {
    display: flex;
    width: var(--col-w);
    flex-shrink: 0;
    padding-left: 16px;
    will-change: transform;
    backface-visibility: hidden;
    transform-style: preserve-3d;
  }
  
  .car-header-fixed {
    // background-color: #f2f2f2;
    // padding: 16px;
    text-align: left;
    width: var(--col-w);
    flex-shrink: 0;
    // border-right: 1px solid #e0e0e0;
    height: var(--header-h);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .car-header-fixed-content {
    display: flex;
    flex-direction: column;
    background-color: rgba(195, 204, 214, 0.5);
    margin: 12px 8px 8px 8px;
    padding: 14px 16px;
    border-radius: 6px;
    // justify-content: center;
    // align-items: center;
  }
  
  // 可滚动容器
  .car-comparison-container-scrollable {
    overflow: auto;
    width: 100%;
    height: calc(100% - var(--header-h)); // 减去固定头部的高度
    margin-top: 0;
    padding: 0 16px;
    /* 触摸：仅允许横向滚动，锁定纵向 */
    touch-action: pan-x;
    overscroll-behavior: contain;
    /* 自定义滚动条样式 */
    &::-webkit-scrollbar {
      width: 0px;
      height: 8px;
    }
    
    &::-webkit-scrollbar-track {
      background: rgba(0, 0, 0, 0.05);
      border-radius: 4px;
    }
    
    &::-webkit-scrollbar-thumb {
      background: rgba(0, 0, 0, 0.2);
      border-radius: 4px;
      transition: background 0.3s ease;
      
      &:hover {
        background: rgba(0, 0, 0, 0.4);
      }
    }
    
    // /* Firefox 滚动条样式 */
    // scrollbar-width: thin;
    // scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);
  }
  
  .car-content-wrapper {
    display: flex;
    width: 100%;
  }
  
  .car-comparison-container {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 0; // 移除顶部边距，因为现在有固定头部
  }
  
  .car-item {
    flex: 1;
    overflow: hidden;
    width: var(--col-w);
    flex-shrink: 0;
  }

  .car-header-placeholder {
    width: var(--col-w); /* 与 car-header 的宽度一致 */
    height: var(--header-h); /* 与 car-header 的高度一致 */
    flex-shrink: 0;
  }
  
  .car-header {
    background-color: #f2f2f2;
    padding: 16px;
    text-align: left;
    width: calc(50vw - 290px);
    height: var(--header-h);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .car-title {
    font-size: 16px;
    margin-bottom: 3px;
    line-height: 1;
    font-family: 'FZLanTingHeiS-DB-GB';
  }
  
  .car-price {
    font-size: 11px;
    color: #000000;
  }
  
  .car-parameters {
    background-color: #fff;
    padding: 8px 8px;
  }
  
  .parameter-item {
    margin-bottom: 8px;
  }
  
  .parameter-title {
    font-size: 14px;
    line-height: 20px;
    padding: 10px 0;
    padding-left: 16px;
    font-family: 'FZLanTingHeiS-B-GB';
  }
  .parameter-title-line {
    border-bottom: 1px solid #00000099;
    // width: calc(100% - 16px);
    margin-bottom: 4px;
  }
  .parameter-content {
    font-family: 'FZLanTingHeiS-R-GB';
    padding: 10px 0;
    padding-left: 16px;
    border-bottom: 1px solid #00000010;
  }
  
  .parameter-name {
    font-size: 12px;
    line-height: 20px;
    width: 450px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .parameter-value {
    font-size: 12px;
    line-height: 20px;
    margin-top: 2px;
  }
  .parameter-title-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  
  .toggle-icon {
    cursor: pointer;
    color: #000;
    font-size: 16px;
    padding: 4px 16px;
  }
  
  .toggle-icon:hover {
    color: #000;
  }
  
  .custom-icon-btn {
    color: black;
    font-size: 14px;
  }
}

/* 移动端样式 */
@media (max-width: 767px) {
  .comparison-container {
    overflow: hidden;
    height: 100%;
    --col-w: calc(244 / 375 * 100vw);
    --header-h: calc(var(--col-w) * (84 / 194));
    /* 预留底部安全区，避免底部内容被系统条或固定元素遮挡 */
    padding-bottom: calc(32 / 375 * 100vw + env(safe-area-inset-bottom, 0px));
    /* 整体竖向滚动由根容器承担 */
    /* 原理：外层承担竖向滚动（overflow-y + touch-action: pan-y），
       浏览器会按手势方向自动“锁轴”，避免横向滚动被触发 */
    overflow-y: auto;
    touch-action: pan-y;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
  }

  .fixed-header-container {
    position: sticky;
    top: 0;
    z-index: 10;
    overflow: hidden;
    height: var(--header-h);
    width: 100%;
  }
  .fixed-header-wrapper {
    display: flex;
    width: var(--col-w);
    flex-shrink: 0;
    padding-left: calc(16 / 375 * 100vw);
    will-change: transform;
  }
  .car-header-fixed {
    text-align: left;
    width: var(--col-w);
    flex-shrink: 0;
    height: var(--header-h);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: center;
    background-color: #fff;
  }
  .car-header-fixed-content {
    height:100%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    background-color: rgba(195, 204, 214, 0.5);
    margin: calc(12 / 375 * 100vw) calc(8 / 375 * 100vw) calc(8 / 375 * 100vw) calc(8 / 375 * 100vw);
    padding: calc(14 / 375 * 100vw) calc(16 / 375 * 100vw);
    border-radius: calc(6 / 375 * 100vw);
  }
  .car-title {
    font-size: calc(20 / 375 * 100vw);
    margin-bottom: calc(6 / 375 * 100vw);
    line-height: 1;
    font-family: 'FZLanTingHeiS-DB-GB';
  }
  
  .car-price {
    font-size: calc(12 / 375 * 100vw);
  }
  .car-comparison-container-scrollable {
    /* 横向滚动由内层承担；允许浏览器按手势自动锁轴，竖向交给外层 */
    /* 原理：仅开启横向滚动（overflow-x），并设置 touch-action:auto，
       浏览器在横向手势时锁轴到 X 方向，从而不触发外层竖向滚动 */
    overflow-x: auto;
    overflow-y: hidden;
    width: 100%;
    height: auto;
    margin-top: 0;
    padding: 0 calc(16 / 375 * 100vw) calc(24 / 375 * 100vw);
    touch-action: auto;
    overscroll-behavior: contain;
    -webkit-overflow-scrolling: touch;
    &::-webkit-scrollbar { width: 0; height: 0; }
  }
  .car-content-wrapper { display: flex; width: 100%; height: 100%; }
  .car-item { width: var(--col-w); flex-shrink: 0; overflow: hidden; height: 100%; display: flex; flex-direction: column; }

  .car-parameters {
    background: #fff;
    padding: calc(8 / 375 * 100vw) calc(8 / 375 * 100vw);
    flex: 1;
    min-height: 0;
    /* 取消列内竖向滚动，由外层承担 */
    /* 原理：避免内层再产生 Y 方向滚动，减少与外层的滚动竞争 */
    overflow: visible;
    touch-action: auto;
  }
  .parameter-item { margin-bottom: calc(8 / 375 * 100vw); }
  .parameter-title { font-size: calc(14 / 375 * 100vw); line-height: 1.4; padding: calc(10 / 375 * 100vw) 0; padding-left: calc(16 / 375 * 100vw); }
  .parameter-title-line { border-bottom: 1px solid #00000099; margin-bottom: calc(4 / 375 * 100vw); }
  .parameter-content { font-size: calc(12 / 375 * 100vw); padding: calc(10 / 375 * 100vw) 0; padding-left: calc(16 / 375 * 100vw); border-bottom: 1px solid #00000010; }
  .parameter-name { font-size: calc(12 / 375 * 100vw); line-height: 1.4; width: calc(450 / 375 * 100vw); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
  .parameter-value { font-size: calc(12 / 375 * 100vw); line-height: 1.4; margin-top: calc(2 / 375 * 100vw); }
  .parameter-title-header { display: flex; justify-content: space-between; align-items: center; }
  .toggle-icon { cursor: pointer; color: #000; font-size: calc(16 / 375 * 100vw); padding: calc(4 / 375 * 100vw) calc(16 / 375 * 100vw); }
  .custom-icon-btn { color: #000; font-size: calc(14 / 375 * 100vw); }
}
  </style>
  